/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../types';

import * as TypescriptOperationsGenerated from "graphql/typescript-operations.generated"
import * as Operations from 'graphql/document-nodes.generated';
import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router'
import { QueryHookOptions, useQuery } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient , ApolloClientContext} from 'withApollo';
export async function getServerPageGetPlatformListingById
    (options: Omit<Apollo.QueryOptions<TypescriptOperationsGenerated.GetPlatformListingByIdQueryQueryVariables>, 'query'>, ctx: ApolloClientContext ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<TypescriptOperationsGenerated.GetPlatformListingByIdQueryQuery>({ ...options, query: Operations.GetPlatformListingByIdQueryDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export const useGetPlatformListingById = (
  optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetPlatformListingByIdQueryQuery, TypescriptOperationsGenerated.GetPlatformListingByIdQueryQueryVariables>) => {
  const router = useRouter();
  const options = optionsFunc ? optionsFunc(router) : {};
  return useQuery(Operations.GetPlatformListingByIdQueryDocument, options);
};
export type PageGetPlatformListingByIdComp = React.FC<{data?: TypescriptOperationsGenerated.GetPlatformListingByIdQueryQuery, error?: Apollo.ApolloError}>;
export const withPageGetPlatformListingById = (optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetPlatformListingByIdQueryQuery, TypescriptOperationsGenerated.GetPlatformListingByIdQueryQueryVariables>) => (WrappedComponent:PageGetPlatformListingByIdComp) : NextPage  => (props) => {
                const router = useRouter()
                const options = optionsFunc ? optionsFunc(router) : {};
                const {data, error } = useQuery(Operations.GetPlatformListingByIdQueryDocument, options)    
                return <WrappedComponent {...props} data={data} error={error} /> ;
                   
            }; 
export const ssrGetPlatformListingById = {
      getServerPage: getServerPageGetPlatformListingById,
      withPage: withPageGetPlatformListingById,
      usePage: useGetPlatformListingById,
    }